import React from "react";
import { Link } from "gatsby";
// import logo from "../assets/images/logo1.png";
import shape1 from "../assets/images/shape/map-shape1.png";
// import shape4 from "../assets/images/shape/vector-shape4.png";
// import shape5 from "../assets/images/shape/vector-shape5.png";
import { request, gql } from "graphql-request";
import { fontsName } from "../assets/fonts/fontsName";
import { REQUEST_URL } from "./RequestUrl";
import "../assets/css/footerStyles.css";

const MAIN_INFO_ABOUT = gql`
  {
    getWebsiteAboutUs {
      _id
      pictureLink
      description
      schoolName
      title
    }
  }
`;

const FOOTER = gql`
  {
    getWebsiteFooter {
      _id
      pictureLink
      description
      address
      socialLinks
      phoneNumbers
      mojavezha
    }
  }
`;

const Footer = () => {
  const [footerInfo, setFooterInfo] = React.useState({});
  const [aboutUsInfo, setAboutUsInfo] = React.useState({});

  React.useEffect(() => {
    request(REQUEST_URL, MAIN_INFO_ABOUT).then((data) => {
      setAboutUsInfo(data.getWebsiteAboutUs);
    });
  }, []);

  React.useEffect(() => {
    request(REQUEST_URL, FOOTER).then((data) => {
      console.log("footer:", data);
      setFooterInfo(data.getWebsiteFooter);
    });
  }, []);

  return (
    <footer
      className="footer-area bg-color"
      dir="rtl"
    //   style={{ marginTop: "30px" }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5">
            <div
              className="single-footer-widget"
            // style={{ textAlign: "right" }}
            >
              <a href="/" className="logo">
                <span style={{ fontFamily: fontsName.VazirBold }}>
                  {aboutUsInfo && aboutUsInfo.schoolName}
                </span>
                {footerInfo && footerInfo.pictureLink !== null && (
                  <img
                    src={footerInfo.pictureLink}
                    alt="logo"
                    style={{ height: "60px" }}
                  />
                )}
              </a>
              <p
                style={{
                  fontFamily: fontsName.VazirBold,
                }}
              >
                {footerInfo && footerInfo.description}
              </p>

              <ul className="social-link">
                {footerInfo &&
                  footerInfo.socialLinks &&
                  footerInfo.socialLinks.length > 0
                  ? footerInfo.socialLinks.map((link, index) => (
                    <li>
                      <Link
                        key={index}
                        to={link}
                        className="d-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {/* <i className="bx bxl-twitter"></i> */}
                        {link.includes("t.me") ? (
                          <i className="bx bxl-telegram"></i>
                        ) : link.includes("instagram.com") ? (
                          <i className="bx bxl-instagram"></i>
                        ) : (
                          link.includes("whatsapp.com") && (
                            <i className="bx bxl-whatsapp"></i>
                          )
                        )}
                      </Link>
                    </li>
                  ))
                  : ""}
                {/* <li>
                  <Link
                    to="#"
                    className="d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bx bxl-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bx bxl-instagram"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bx bxl-linkedin"></i>
                  </Link>
                </li> */}
              </ul>
            </div>
            <div className="map-shape1">
              <img src={shape1} alt="banner" />
            </div>
            {/* <div className="vector-shape5">
              <img src={shape5} alt="banner" />
            </div> */}
          </div>

          <div
            className="contact-widget col-md-7"
            style={{ fontFamily: fontsName.Vazir, display: "flex" }}
          >
            <div className="single-footer-widget">
              <h3 style={{ fontFamily: fontsName.Vazir }}>ارتباطات</h3>

              <ul className="footer-contact-info">
                <li>
                  <i className="bx bx-map"></i>
                  {/* مازندران، بابل <br /> کمربندی شرقی، گلستان 15
                  <br /> مرکز رشد دانشگاه صنعتی نوشیروانی <br /> شرکت فنی مهندسی
                  رایمون فناور آسیا */}
                  {footerInfo && footerInfo.address}
                </li>
                {footerInfo &&
                  footerInfo.phoneNumbers &&
                  footerInfo.phoneNumbers.length > 0
                  ? footerInfo.phoneNumbers.map((call, index) => (
                    <li>
                      <i className="bx bx-phone-call"></i>
                      <a href={`tel:${call}`}>{call}</a>
                    </li>
                  ))
                  : ""}
                {/* <li>
                  <i className="bx bx-phone-call"></i>
                  <a href="tel:98119999999">011-9999999</a>
                </li> */}
                {/* <li>
                  <i className="bx bx-phone-call"></i>
                  <a href="tel:989119999999">0911-9999999</a>
                </li>
                <li>
                  <i className="bx bx-envelope"></i>
                  <a href="mailto:email-address@gmail.com">
                    email-address@gmail.com
                  </a>
                </li> */}
              </ul>
            </div>
            <div className="footer-logo-container">
              {/* ENAMAD */}
              {footerInfo &&
                footerInfo.mojavezha &&
                footerInfo.mojavezha.map((mojavez, index) => (
                  <div
                    className="footer-logo"
                    key={index}
                    dangerouslySetInnerHTML={{ __html: mojavez }}
                  />
                ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom-area">
          <div style={{ textAlign: "center" }} className="row">
            <div
              style={{ fontFamily: fontsName.Vazir }}
              className="col-sm-12"
            >
              <p>
                تمام حقوق مادی و معنوی این سایت متعلق به{" "}
                <a target="_blank" href="#" rel="noreferrer">
                  رایمون فناور آسیا
                </a>{" "}
                می باشد.
              </p>
            </div>

            {/* <div className="col-lg-6 col-md-6">
							<ul>
								<li>
									<Link to="/privacy-policy">Privacy Policy</Link>
								</li>
								<li>
									<Link to="/terms-of-service">Terms & Conditions</Link>
								</li>
							</ul>
						</div> */}
          </div>
        </div>
      </div>

      {/* <div className="vector-shape4">
        <img src={shape4} alt="banner" />
      </div> */}
    </footer>
  );
};

export default Footer;
